// src/pages/SupportPage.jsx
import React from "react";

const SUPPORT_EMAIL = "support@starepochlabs.com";
const MAILING_ADDRESS_ONE_LINE = "30 N Gould St Ste N, Sheridan, WY 82801";

export default function SupportPage() {
  return (
    <div className="space-y-10">
      <section className="rounded-3xl border border-white/10 bg-white/5 p-10">
        <p className="text-sm font-semibold text-cyan-300/90 text-center">Support</p>

        <h2 className="mt-3 text-center text-3xl font-semibold tracking-tight text-white">
          We’re here to help
        </h2>

        <p className="mt-4 mx-auto max-w-3xl text-center text-base leading-7 text-white/75">
          If you need assistance, email us at{" "}
          <a className="text-white hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>
            {SUPPORT_EMAIL}
          </a>
          . We typically respond within <b>1–2 business days</b>.
        </p>

        <div className="mt-8 mx-auto grid max-w-4xl gap-6 md:grid-cols-2">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Contact</div>

            <div className="mt-3 text-sm text-white/70">
              Email:{" "}
              <a className="text-white hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
            </div>

            <div className="mt-2 text-sm text-white/70">
              Mailing address:{" "}
              <span className="text-white/80">{MAILING_ADDRESS_ONE_LINE}</span>
            </div>

            <div className="mt-3 text-xs text-white/55">
              Tip: Including your device model, OS version, and app version helps us resolve issues faster.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Billing & subscriptions</div>

            <div className="mt-3 text-sm leading-relaxed text-white/70">
              If you subscribe through the App Store, billing and subscription management are handled by Apple.
              You can manage your subscription in iOS Settings → Apple ID → Subscriptions. For refunds,
              please follow Apple’s refund process and policies.
            </div>
          </div>
        </div>

        <div className="mt-8 mx-auto max-w-4xl rounded-2xl border border-white/10 bg-white/5 p-7">
          <div className="text-sm font-semibold text-white">Common questions</div>

          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li>
              • <b>How do I contact support?</b> — Email us with a short description, your device model,
              OS version, and app version.
            </li>
            <li>
              • <b>Connection issues</b> — Include approximate time of the issue and any error message shown
              in the app (if available).
            </li>
            <li>
              • <b>Subscription</b> — Manage subscriptions in iOS Settings → Apple ID → Subscriptions.
            </li>
            <li>
              • <b>Privacy requests</b> — For privacy-related questions, email{" "}
              <a className="text-white hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
              .
            </li>
          </ul>
        </div>

        <div className="mt-6 text-xs text-white/50">
          Note: Support content may be updated as the app evolves and new features are released.
        </div>
      </section>
    </div>
  );
}
